import { CrispChat } from "./crisp-chat"

export const CrispProvider = () => {
    return <CrispChat />
}